import { router } from '../router';
export class Microfrontend {
    constructor(params) {
        this.params = params;
    }
    mount(el, props) {
        var _a, _b, _c;
        this.params.mount(el, props);
        if ((_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.microfrontendOptions) === null || _b === void 0 ? void 0 : _b.onRouteChange) {
            router.listen((_c = this.params.microfrontendOptions) === null || _c === void 0 ? void 0 : _c.onRouteChange);
        }
    }
    unmount(el) {
        var _a;
        if ((_a = this.params.microfrontendOptions) === null || _a === void 0 ? void 0 : _a.onRouteChange) {
            router.removeListen(this.params.microfrontendOptions.onRouteChange);
        }
        this.params.unmount(el);
    }
}
